import { useUiStateContext } from '@frontend/utils';
import type { IUiState } from './uiStateContext';
import type { UiStateAction } from './uiStateReducer';

type UseUIStateWrapperChildren = (
    uiState?: IUiState,
    dispatchUiStateAction?: React.Dispatch<UiStateAction>
) => JSX.Element;

interface IUseUIStateWrapperProps {
    children?: UseUIStateWrapperChildren;
}

export function UseUIStateWrapper({ children }: IUseUIStateWrapperProps) {
    const { uiState, dispatchUiStateAction } = useUiStateContext();

    return children && children(uiState, dispatchUiStateAction);
}
